import React from "react";

interface TableCellTextProps
  extends React.HTMLAttributes<HTMLTableCellElement> {
  children: React.ReactNode;
  className?: string;
}

export const TableCellText = ({
  children,
  className,
  ...rest
}: TableCellTextProps) => {
  return (
    <td className={`${className ?? ""} pl-3`} {...rest}>
      {children}
    </td>
  );
};
